<template>
    <div class="footer-container ipx-btm" @click="clickFooter">
        <button class="btn-wrap" :style="bgStyle">{{buttonName}}</button>
        <div class="flex buy-info">
            <!-- <div class="item flex">
                <img src="https://s20.lgstatic.com/growth/activity/20220415/1650007803376.png" alt="">
                <p class="">咨询课程顾问 立抢大额优惠券</p>
            </div> -->
            <!-- <div class="item flex">
                <img src="https://s21.lgstatic.com/growth/activity/20211209/1639029483994.png" alt="">
                <p class="">0手续费</p>
            </div>
             <div class="item flex">
                <img src="https://s21.lgstatic.com/growth/activity/20211209/1639029483994.png" alt="">
                <p class="">0利息</p>
            </div> -->
        </div>
        <div class="img-box">
            <img
                class="img-btns"
                src="https://s21.lgstatic.com/growth/activity/20211210/1639129983847.png"
            >
        </div>
         <FooterPoup
            v-if="showPoup"
            :id="id"
            :isDcsj="isDcsj"
        />
    </div>
</template>
<script>
import  FooterPoup  from  '../FooterPoup'
    export default {
        props: {
            buttonName: {
                type: String,
                default: '名额有限 立即抢占'
            },
            bgStyle:{
                type:Object,
                default:()=>{}
            },
            isDcsj:{
                type:Boolean,
                default:false
            },
            id:{
                type:Number,
                default:0
            },
            showPoup:{
                type:Boolean,
                default:false
            }
        },
        components: {
            FooterPoup,
        },
        methods: {
            clickFooter() {
                this.$emit('jump')
            }
        },

    }
</script>

<style lang="less" scoped>
.footer-container{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 150px;
    padding: 12px 0;
    background-color: #fff;
    box-sizing: border-box;
    z-index: 999;
    .btn-wrap{
        width: 690px;
        height: 88px;
        line-height: 88px;
        outline: none;
        border: none;
        font-size: 36px;
        margin: 12px auto 0;
        display: block;
        color: #fff;
        font-weight: 500;
        border-radius: 24px;
    }
    .buy-info{
        font-size: 24px;
        color: #666;
        justify-content: center;
        align-items: center;
        .item{
            margin-top: 22px;
            align-items: center;
        }
        .item:not(:first-child){
            margin-left: 54px;
        }
        img{
            width: 32px;
            height: 32px;
            display: inline-block;
            margin-right: 8px;
        }
    }
    .img-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100px;
    }
    .img-btns {
        position: absolute;
        top: 0px;
        left: 0px;
        animation: light 2s infinite linear;
        width: 224px;
        height: 120px;
    }
    @keyframes  light{
        0% {
            left: -50%;
        }
        50% {
            left: 100%;
        }
        100% {
            left: 200%;
        }
    }

}
 @supports (padding-bottom: constant(safe-area-inset-bottom)) or (padding-bottom: env(safe-area-inset-bottom)) {
    .ipx-btm {
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
    }
  }
</style>